import React from 'react';
import { CircularProgress } from '@mui/material';
import { Box } from '../Box';
import { LoaderOverlayProps } from './types';

export const LoaderOverlay: React.FC<LoaderOverlayProps> = ({ isLoading }) => {
  if (!isLoading) {
    return null;
  }

  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      display="flex"
      justifyContent="center"
      alignItems="center"
      bgColor="grey-300"
      opacity={0.7}
      sx={{
        zIndex: 10,
      }}>
      <CircularProgress color="secondary" />
    </Box>
  );
};
